module.exports = __webpack_public_path__ + "img/security.b76d5047.svg";